function MeshesPage() {
    /**
     *
     */
    MeshesPage.prototype.initialize = function (console, meshes) {
        this.id = "meshes";
        this.console = console;
        this.meshes = meshes;

        return this;
    };

    /**
     *
     */
    MeshesPage.prototype.show = function () {
        var deferred = $.Deferred();

        this.console.consoleService
            .getMeshes()
            .done(
                function (meshes) {
                    this.meshes = meshes;

                    deferred.resolve();
                }.bind(this)).fail(function (error) {
            this.console.consoleService.logError(error);

            deferred.reject(error);
        });

        return deferred.promise();
    };

    /**
     *
     */
    MeshesPage.prototype.leave = function () {
    };
}
